var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Carousel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.167 3.125H8.16699V16.875H13.167V3.125ZM14.417 15.2083H17.2295C18.092 15.2083 18.792 14.5083 18.792 13.6458V6.35417C18.792 5.49083 18.092 4.79167 17.2295 4.79167H14.417V15.2083ZM4.10449 4.79167H6.91699V15.2083H4.10449C3.69009 15.2083 3.29266 15.0437 2.99964 14.7507C2.70661 14.4577 2.54199 14.0602 2.54199 13.6458V6.35417C2.54199 5.49083 3.24199 4.79167 4.10449 4.79167Z",
    fill: "#CDCED6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousel);
export default __webpack_public_path__ + "static/media/carousel.8b709bfbfb797573c8a9111d4aaacfdb.svg";
export { ForwardRef as ReactComponent };